import React, { useState, useEffect } from 'react';
import { todoService } from '../services/todoService';
import '../styles/SyncSettings.css';

const SyncSettings = ({ onSync }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [syncId, setSyncId] = useState('');
  const [inputSyncId, setInputSyncId] = useState('');
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  // Load the current sync ID when the component mounts
  useEffect(() => {
    const currentSyncId = todoService.getSyncId();
    setSyncId(currentSyncId || '');
  }, []);

  // Generate a new sync ID
  const handleGenerateId = () => {
    try {
      const newId = todoService.generateSyncId();
      setSyncId(newId);
      setError('');
      
      // Trigger a sync to save with the new ID
      if (onSync) {
        onSync();
      }
    } catch (error) {
      setError('Failed to generate sync ID');
    }
  };

  // Set a custom sync ID
  const handleSetSyncId = () => {
    if (!inputSyncId || inputSyncId.trim() === '') {
      setError('Please enter a valid sync ID');
      return;
    }

    try {
      todoService.setSyncId(inputSyncId);
      setSyncId(inputSyncId);
      setInputSyncId('');
      setError('');
      
      // Trigger a sync to load data with the new ID
      if (onSync) {
        onSync();
      }
    } catch (error) {
      setError(error.message);
    }
  };

  // Copy the sync ID to clipboard
  const handleCopyId = () => {
    if (syncId) {
      navigator.clipboard.writeText(syncId)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch(() => {
          setError('Failed to copy to clipboard');
        });
    }
  };

  return (
    <div className="sync-settings">
      <button 
        className="sync-settings-toggle" 
        onClick={() => setIsOpen(!isOpen)}
        title="Sync Settings"
      >
        <span role="img" aria-label="Sync Settings">🔄</span> Sync Across Devices
      </button>
      
      {isOpen && (
        <div className="sync-settings-panel">
          <h3>Sync Settings</h3>
          <p className="sync-description">
            Use the same Sync ID across devices to share your todos.
          </p>
          
          {syncId ? (
            <div className="current-sync-id">
              <p>Current Sync ID:</p>
              <div className="sync-id-display">
                <span>{syncId}</span>
                <button 
                  onClick={handleCopyId} 
                  className="copy-button"
                  title="Copy to clipboard"
                >
                  {copied ? '✓' : '📋'}
                </button>
              </div>
            </div>
          ) : (
            <p>No Sync ID set. Generate one below.</p>
          )}
          
          <div className="sync-actions">
            <button 
              onClick={handleGenerateId}
              className="generate-button"
            >
              Generate New ID
            </button>
          </div>
          
          <div className="sync-id-input">
            <p>Enter Sync ID from another device:</p>
            <div className="input-group">
              <input
                type="text"
                value={inputSyncId}
                onChange={(e) => setInputSyncId(e.target.value)}
                placeholder="e.g. ABCD-1234"
              />
              <button onClick={handleSetSyncId}>Use</button>
            </div>
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <button 
            className="close-button"
            onClick={() => setIsOpen(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default SyncSettings; 